import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteVehicleRes;
export const DeleteVehicleTodo = createAsyncThunk('DeleteVehicle', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `vehicle_master/${id}`,
          
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteVehicleRes = res.data
        
    } catch (error) {
        return DeleteVehicleRes = error.response.data
    }
})
